export default {
    init() {
        const tl = gsap.timeline()
        tl.fromTo(
            '[data-header-logo]',
            { opacity: 0, scale: 1.2 },
            {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                delay: 1.5,
                ease: 'quad.inOut',
            },
        )
            .fromTo(
                '[data-header-nav]',
                { opacity: 0, y: '1.5rem' },
                { opacity: 1, y: '0', duration: 0.5, ease: 'circ.out' },
                '<0.75',
            )
            .to('[data-header-phone]', { opacity: 1, duration: 0.3, ease: 'quad.inOut' }, '<0.2')
    },
}
